import { gql } from '@apollo/client';

export const GET_MONITORING_FORM_CURRENCY_VALUES = gql`
  query GetMonitoringFormCurrencyValues($input: GetMonitoringFormCurrencyValuesInput!) {
    currencyValues: getMonitoringFormCurrencyValues(input: $input) {
      currencyGroupId
      name
      exchangeRate
      periodDateId
      periodDate
      periodLabel
      value
    }
  }
`;
